import { Package, Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useGetVendorMeQuery } from '../../../store/vendorApi';

export default function TeamProductsTab() {
  const { t } = useTranslation();
  const { data: vendor, isLoading } = useGetVendorMeQuery();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader className="w-6 h-6 animate-spin text-purple-600" />
      </div>
    );
  }

  const products = vendor?.pageInfo?.products ?? [];

  if (products.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        <Package className="w-10 h-10 mx-auto mb-3 text-gray-300" />
        <p>{t('teamSettings.products.empty')}</p>
      </div>
    );
  }

  return (
    <div>
      <p className="text-sm text-gray-500 mb-4">{t('teamSettings.products.intro')}</p>
      <div className="space-y-3">
        {products.map((product, idx) => (
          <div key={idx} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg border border-gray-100">
            <Package className="w-5 h-5 text-purple-500 mt-0.5 shrink-0" />
            <div className="min-w-0">
              <p className="font-medium text-gray-900">{product.name}</p>
              {product.description && (
                <p className="text-sm text-gray-600 mt-1">{product.description}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
